var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: {
        width: "100%",
        "font-size": "14px",
        height: "100%",
        "padding-left": "12px",
        "padding-right": "12px",
        "box-sizing": "border-box",
      },
    },
    _vm._l(_vm.arr, function (row, indey) {
      return _c("div", { key: indey }, [
        _vm._m(0, true),
        _c(
          "table",
          {
            staticClass: "table1",
            staticStyle: {
              "border-collapse": "collapse",
              "border-spacing": "0",
              border: "1px solid rgb(128 128 128)",
              "margin-top": "8px",
              "table-layout": "fixed",
              "word-break": "break-word",
            },
            attrs: {
              width: "100%",
              height: "100%",
              cellpadding: "0",
              cellspacing: "0",
              border: "0",
            },
          },
          [
            _c("tr", { staticClass: "border-b" }, [
              _vm._m(1, true),
              _c("td", { staticClass: "border-r", attrs: { colspan: "8" } }, [
                _vm._v(_vm._s(_vm.findLabel("recruit_post", row.recruitPost))),
              ]),
              _vm._m(2, true),
              _c("td", { staticClass: "border-n", attrs: { colspan: "8" } }, [
                _vm._v(
                  _vm._s(row.createdTime.split("-")[0]) +
                    "年" +
                    _vm._s(row.createdTime.split("-")[1]) +
                    "月" +
                    _vm._s(row.createdTime.split("-")[2]) +
                    "日 "
                ),
              ]),
            ]),
            _c("tr", [
              _vm._m(3, true),
              _c("td", { staticClass: "border-b-r", attrs: { colspan: "2" } }, [
                _vm._v(_vm._s(row.name)),
              ]),
              _vm._m(4, true),
              _c("td", { staticClass: "border-b-r", attrs: { colspan: "2" } }, [
                _vm._v(_vm._s(row.gender == 1 ? "男" : "女") + " "),
              ]),
              _vm._m(5, true),
              _c("td", { staticClass: "border-b-r", attrs: { colspan: "2" } }, [
                _vm._v(_vm._s(row.nation)),
              ]),
              _vm._m(6, true),
              _c("td", { staticClass: "border-b-r", attrs: { colspan: "4" } }, [
                _vm._v(_vm._s(row.nativePlace)),
              ]),
              _c(
                "td",
                {
                  staticClass: "border-n",
                  attrs: { colspan: "4", rowspan: "5" },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "center",
                      },
                    },
                    [
                      row.image
                        ? _c("img", {
                            staticClass: "avatar",
                            staticStyle: {
                              width: "90px",
                              height: "120px",
                              "object-fit": "cover",
                            },
                            attrs: { src: row.image },
                          })
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
            ]),
            _c("tr", [
              _vm._m(7, true),
              _c("td", { staticClass: "border-b-r", attrs: { colspan: "2" } }, [
                _vm._v(_vm._s(_vm.findLabel("zodiac", row.zodiac))),
              ]),
              _vm._m(8, true),
              _c("td", { staticClass: "border-b-r", attrs: { colspan: "2" } }, [
                _vm._v(_vm._s(row.height)),
              ]),
              _vm._m(9, true),
              _c("td", { staticClass: "border-b-r", attrs: { colspan: "2" } }, [
                _vm._v(_vm._s(row.weight)),
              ]),
              _vm._m(10, true),
              _c("td", { staticClass: "border-b-r", attrs: { colspan: "4" } }, [
                _vm._v(_vm._s(row.dateOfBirth)),
              ]),
            ]),
            _c("tr", [
              _vm._m(11, true),
              _c("td", { attrs: { colspan: "4" } }, [
                _vm._v(
                  _vm._s(
                    _vm.findLabel(
                      "political_affiliation",
                      row.politicalAffiliation
                    )
                  ) + " "
                ),
              ]),
              _vm._m(12, true),
              _c("td", { attrs: { colspan: "8" } }, [
                _vm._v(_vm._s(row.phone)),
              ]),
            ]),
            _c("tr", { staticClass: "border-b" }, [
              _vm._m(13, true),
              _c(
                "td",
                { attrs: { colspan: "4", rowspan: "2" } },
                _vm._l(_vm.dictionaries.marital_status, function (item, indz) {
                  return item.dictId == row.maritalStatus
                    ? _c(
                        "span",
                        {
                          key: indz,
                          staticStyle: {
                            "margin-right": "4px",
                            "min-width": "44px",
                          },
                        },
                        [_vm._v(" " + _vm._s(item.dictName) + " ")]
                      )
                    : _vm._e()
                }),
                0
              ),
              _vm._m(14, true),
              _c("td", { attrs: { colspan: "8" } }, [
                _vm._v(" " + _vm._s(row.wechatNumber)),
              ]),
            ]),
            _c("tr", { staticClass: "border-b" }, [
              _c(
                "td",
                {
                  staticStyle: { "background-color": "#E7EDF8" },
                  attrs: { colspan: "4" },
                },
                [_vm._v(" 邮箱地址 ")]
              ),
              _c("td", { attrs: { colspan: "8" } }, [
                _vm._v(_vm._s(row.email)),
              ]),
            ]),
            _c("tr", { staticClass: "border-b" }, [
              _vm._m(15, true),
              _c("td", { attrs: { colspan: "4" } }, [
                _vm._v(
                  _vm._s(
                    _vm.findLabel("educational_level", row.educationalLevel)
                  )
                ),
              ]),
              _vm._m(16, true),
              _c("td", { attrs: { colspan: "4" } }, [
                _vm._v(_vm._s(row.desiredSalary)),
              ]),
              _vm._m(17, true),
              _c("td", { staticClass: "border-n", attrs: { colspan: "4" } }, [
                _vm._v(_vm._s(row.availableTime)),
              ]),
            ]),
            _c("tr", { staticClass: "border-b" }, [
              _vm._m(18, true),
              _c("td", { attrs: { colspan: "8" } }, [
                _vm._v(_vm._s(row.idCardNumber)),
              ]),
              _vm._m(19, true),
              _c("td", { staticClass: "border-n", attrs: { colspan: "8" } }, [
                row.householdType == 1
                  ? _c("span", [_vm._v("农村户口")])
                  : row.householdType == 2
                  ? _c("span", [_vm._v("城镇户口")])
                  : _vm._e(),
              ]),
            ]),
            _c("tr", { staticClass: "border-b" }, [
              _vm._m(20, true),
              _c("td", { attrs: { colspan: "8" } }, [
                _c(
                  "div",
                  { staticStyle: { "line-height": "1.3", padding: "4px 0" } },
                  [_vm._v(_vm._s(row.householdResidenceDetail))]
                ),
              ]),
              _vm._m(21, true),
              _c("td", { staticClass: "border-n", attrs: { colspan: "8" } }, [
                _c(
                  "div",
                  { staticStyle: { "line-height": "1.3", padding: "4px 0" } },
                  [_vm._v(_vm._s(row.currentResidenceDetail))]
                ),
              ]),
            ]),
            _c("tr", { staticClass: "border-b" }, [
              _vm._m(22, true),
              _c("td", { attrs: { colspan: "2" } }, [
                row.kinFlag == 1
                  ? _c("span", [_vm._v("是")])
                  : row.kinFlag == 0
                  ? _c("span", [_vm._v("否")])
                  : _vm._e(),
              ]),
              _vm._m(23, true),
              _c("td", { attrs: { colspan: "4" } }, [
                _vm._v(_vm._s(row.kinName)),
              ]),
              _vm._m(24, true),
              _c("td", { attrs: { colspan: "2" } }, [
                _vm._v(_vm._s(row.kinRelationship)),
              ]),
              _vm._m(25, true),
              _c("td", { staticClass: "border-n", attrs: { colspan: "4" } }, [
                _vm._v(_vm._s(row.kinOrganization)),
              ]),
            ]),
            _c("tr", { staticClass: "border-b" }, [
              _vm._m(26, true),
              _c("td", { attrs: { colspan: "12" } }, [
                _vm._v(_vm._s(row.hobby)),
              ]),
              _vm._m(27, true),
              _c("td", { staticClass: "border-n", attrs: { colspan: "4" } }, [
                _vm._v(
                  _vm._s(
                    _vm.findLabel(
                      "driving_license_level",
                      row.drivingLicenseLevel
                    )
                  )
                ),
              ]),
            ]),
            row.educationList.length != 0
              ? _c(
                  "tr",
                  {
                    staticClass: "border-b",
                    staticStyle: { "background-color": "#E7EDF8" },
                  },
                  [
                    _c(
                      "td",
                      {
                        staticStyle: { "background-color": "#E7EDF8" },
                        attrs: {
                          colspan: "4",
                          rowspan: row.educationList.length + 1,
                        },
                      },
                      [_vm._m(28, true)]
                    ),
                    _vm._m(29, true),
                    _vm._m(30, true),
                    _vm._m(31, true),
                    _vm._m(32, true),
                    _vm._m(33, true),
                  ]
                )
              : _vm._e(),
            _vm._l(row.educationList, function (item, index) {
              return _c(
                "tr",
                { staticClass: "border-b" },
                [
                  item
                    ? [
                        _c("td", { attrs: { colspan: "4" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "line-height": "1",
                                padding: "4px 0",
                                "font-size": "13px",
                              },
                            },
                            [
                              _vm._v(_vm._s(item.startTime)),
                              _c(
                                "span",
                                { staticStyle: { "font-size": "12px" } },
                                [_vm._v("至")]
                              ),
                              _c("br"),
                              _vm._v(_vm._s(item.endTime)),
                            ]
                          ),
                        ]),
                        _c("td", { attrs: { colspan: "6" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "line-height": "1.2",
                                padding: "4px 0",
                              },
                            },
                            [_vm._v(_vm._s(item.institutionName))]
                          ),
                        ]),
                        _c("td", { attrs: { colspan: "4" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "line-height": "1.2",
                                padding: "4px 0",
                              },
                            },
                            [_vm._v(_vm._s(item.major))]
                          ),
                        ]),
                        _c("td", { attrs: { colspan: "2" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.findLabel(
                                "educational_level",
                                item.educationalLevel
                              )
                            )
                          ),
                        ]),
                        _c(
                          "td",
                          { staticClass: "border-n", attrs: { colspan: "4" } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.findLabel(
                                  "educational_mode",
                                  item.educationalMode
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    : [
                        _c("td", { attrs: { colspan: "4" } }, [_vm._v(" ")]),
                        _c("td", { attrs: { colspan: "6" } }, [_vm._v(" ")]),
                        _c("td", { attrs: { colspan: "4" } }, [_vm._v(" ")]),
                        _c("td", { attrs: { colspan: "2" } }, [_vm._v(" ")]),
                        _c(
                          "td",
                          { staticClass: "border-n", attrs: { colspan: "4" } },
                          [_vm._v(" ")]
                        ),
                      ],
                ],
                2
              )
            }),
            row.workRecordList.length != 0
              ? _c(
                  "tr",
                  {
                    staticClass: "border-b",
                    staticStyle: { "background-color": "#E7EDF8" },
                  },
                  [
                    _c(
                      "td",
                      {
                        staticStyle: { "background-color": "#E7EDF8" },
                        attrs: {
                          colspan: "4",
                          rowspan: row.workRecordList.length + 1,
                        },
                      },
                      [_vm._m(34, true)]
                    ),
                    _vm._m(35, true),
                    _vm._m(36, true),
                    _vm._m(37, true),
                    _vm._m(38, true),
                    _vm._m(39, true),
                    _vm._m(40, true),
                  ]
                )
              : _vm._e(),
            _vm._l(row.workRecordList, function (item, index) {
              return _c(
                "tr",
                { staticClass: "border-b" },
                [
                  item
                    ? [
                        _c("td", { attrs: { colspan: "4" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "line-height": "1",
                                padding: "4px 0",
                                "font-size": "13px",
                              },
                            },
                            [
                              _vm._v(_vm._s(item.startTime)),
                              _c(
                                "span",
                                { staticStyle: { "font-size": "12px" } },
                                [_vm._v("至")]
                              ),
                              _c("br"),
                              _vm._v(_vm._s(item.endTime)),
                            ]
                          ),
                        ]),
                        _c("td", { attrs: { colspan: "4" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "line-height": "1.2",
                                padding: "2px 0",
                              },
                            },
                            [_vm._v(_vm._s(item.company))]
                          ),
                        ]),
                        _c("td", { attrs: { colspan: "4" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "line-height": "1.2",
                                padding: "2px 0",
                              },
                            },
                            [
                              _vm._v(_vm._s(item.organization)),
                              _c("br"),
                              _vm._v(_vm._s(item.post)),
                            ]
                          ),
                        ]),
                        _c("td", { attrs: { colspan: "3" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.findLabel(
                                "resignation_reason",
                                item.resignationReason
                              )
                            )
                          ),
                        ]),
                        _c("td", { attrs: { colspan: "3" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "line-height": "1.2",
                                padding: "2px 0",
                              },
                            },
                            [
                              _vm._v(_vm._s(item.certifier)),
                              _c("br"),
                              _vm._v(_vm._s(item.phone)),
                            ]
                          ),
                        ]),
                        _c(
                          "td",
                          { staticClass: "border-n", attrs: { colspan: "2" } },
                          [_vm._v(_vm._s(item.salary))]
                        ),
                      ]
                    : [
                        _c("td", { attrs: { colspan: "4" } }, [_vm._v(" ")]),
                        _c("td", { attrs: { colspan: "4" } }, [_vm._v(" ")]),
                        _c("td", { attrs: { colspan: "4" } }, [_vm._v(" ")]),
                        _c("td", { attrs: { colspan: "3" } }, [_vm._v(" ")]),
                        _c("td", { attrs: { colspan: "3" } }, [_vm._v(" ")]),
                        _c(
                          "td",
                          { staticClass: "border-n", attrs: { colspan: "2" } },
                          [_vm._v(" ")]
                        ),
                      ],
                ],
                2
              )
            }),
            row.trainingInfoList.length != 0
              ? _c(
                  "tr",
                  {
                    staticClass: "border-b",
                    staticStyle: { "background-color": "#E7EDF8" },
                  },
                  [
                    _c(
                      "td",
                      {
                        staticStyle: { "background-color": "#E7EDF8" },
                        attrs: {
                          colspan: "4",
                          rowspan: row.trainingInfoList.length + 1,
                        },
                      },
                      [
                        _c("div", { attrs: { align: "center" } }, [
                          _vm._v("培训经历"),
                        ]),
                      ]
                    ),
                    _vm._m(41, true),
                    _vm._m(42, true),
                    _vm._m(43, true),
                    _vm._m(44, true),
                    _vm._m(45, true),
                  ]
                )
              : _vm._e(),
            _vm._l(row.trainingInfoList, function (item, index) {
              return _c(
                "tr",
                { staticClass: "border-b" },
                [
                  item
                    ? [
                        _c("td", { attrs: { colspan: "4" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "line-height": "1",
                                padding: "4px 0",
                                "font-size": "13px",
                              },
                            },
                            [
                              _vm._v(_vm._s(item.startTime)),
                              _c(
                                "span",
                                { staticStyle: { "font-size": "12px" } },
                                [_vm._v("至")]
                              ),
                              _c("br"),
                              _vm._v(_vm._s(item.endTime)),
                            ]
                          ),
                        ]),
                        _c("td", { attrs: { colspan: "4" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "line-height": "1.2",
                                padding: "2px 0",
                              },
                            },
                            [_vm._v(_vm._s(item.institutionName))]
                          ),
                        ]),
                        _c("td", { attrs: { colspan: "4" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "line-height": "1.2",
                                padding: "2px 0",
                              },
                            },
                            [_vm._v(_vm._s(item.certificate))]
                          ),
                        ]),
                        _c("td", { attrs: { colspan: "4" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "line-height": "1.2",
                                padding: "2px 0",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.findLabel(
                                    "training_mode",
                                    item.trainingMode
                                  )
                                )
                              ),
                            ]
                          ),
                        ]),
                        _c(
                          "td",
                          { staticClass: "border-n", attrs: { colspan: "4" } },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "line-height": "1.2",
                                  padding: "2px 0",
                                },
                              },
                              [_vm._v(_vm._s(item.trainingContent))]
                            ),
                          ]
                        ),
                      ]
                    : [
                        _c("td", { attrs: { colspan: "2" } }, [_vm._v(" ")]),
                        _c("td", { attrs: { colspan: "2" } }, [_vm._v(" ")]),
                        _c("td", { attrs: { colspan: "4" } }, [_vm._v(" ")]),
                        _c("td", { attrs: { colspan: "4" } }, [_vm._v(" ")]),
                        _c(
                          "td",
                          { staticClass: "border-n", attrs: { colspan: "4" } },
                          [_vm._v(" ")]
                        ),
                      ],
                ],
                2
              )
            }),
            row.familyInfoList.length != 0
              ? _c(
                  "tr",
                  {
                    staticClass: "border-b",
                    staticStyle: { "background-color": "#E7EDF8" },
                  },
                  [
                    _c(
                      "td",
                      {
                        staticStyle: { "background-color": "#E7EDF8" },
                        attrs: {
                          rowspan: row.familyInfoList.length + 1,
                          colspan: "4",
                        },
                      },
                      [
                        _c("div", { attrs: { align: "center" } }, [
                          _vm._v("家庭成员"),
                        ]),
                      ]
                    ),
                    _vm._m(46, true),
                    _vm._m(47, true),
                    _vm._m(48, true),
                    _vm._m(49, true),
                    _vm._m(50, true),
                  ]
                )
              : _vm._e(),
            _vm._l(row.familyInfoList, function (item, index) {
              return _c(
                "tr",
                { staticClass: "border-b" },
                [
                  item
                    ? [
                        _c("td", { attrs: { colspan: "4" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "line-height": "1.2",
                                padding: "6px 0",
                              },
                            },
                            [_vm._v(_vm._s(item.name))]
                          ),
                        ]),
                        _c("td", { attrs: { colspan: "4" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "line-height": "1.2",
                                padding: "6px 0",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.findLabel(
                                    "family_relationships",
                                    item.familyRelationships
                                  )
                                )
                              ),
                            ]
                          ),
                        ]),
                        _c("td", { attrs: { colspan: "4" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "line-height": "1.2",
                                padding: "6px 0",
                              },
                            },
                            [_vm._v(_vm._s(item.company))]
                          ),
                        ]),
                        _c("td", { attrs: { colspan: "4" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "line-height": "1.2",
                                padding: "6px 0",
                              },
                            },
                            [_vm._v(_vm._s(item.post))]
                          ),
                        ]),
                        _c(
                          "td",
                          { staticClass: "border-n", attrs: { colspan: "4" } },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "line-height": "1.2",
                                  padding: "6px 0",
                                },
                              },
                              [_vm._v(_vm._s(item.phone))]
                            ),
                          ]
                        ),
                      ]
                    : [
                        _c("td", { attrs: { colspan: "4" } }, [_vm._v(" ")]),
                        _c("td", { attrs: { colspan: "4" } }, [_vm._v(" ")]),
                        _c("td", { attrs: { colspan: "4" } }, [_vm._v(" ")]),
                        _c("td", { attrs: { colspan: "4" } }, [_vm._v(" ")]),
                        _c(
                          "td",
                          { staticClass: "border-n", attrs: { colspan: "4" } },
                          [_vm._v(" ")]
                        ),
                      ],
                ],
                2
              )
            }),
            _c("tr", { staticClass: "border-b" }, [
              _vm._m(51, true),
              _c("td", { attrs: { colspan: "8" } }, [
                _c("div", { attrs: { align: "center" } }, [
                  _vm._v(_vm._s(row.emergencyContactName)),
                ]),
              ]),
              _vm._m(52, true),
              _c("td", { staticClass: "border-n", attrs: { colspan: "8" } }, [
                _c("div", { attrs: { align: "center" } }, [
                  _vm._v(_vm._s(row.emergencyContactPhone)),
                ]),
              ]),
            ]),
            _c("tr", { staticClass: "border-b" }, [
              _vm._m(53, true),
              _c("td", { attrs: { colspan: "2" } }, [
                row.dispute != ""
                  ? _c("span", [_vm._v("是")])
                  : row.dispute == "" || row.dispute == null
                  ? _c("span", [_vm._v("否")])
                  : _vm._e(),
              ]),
              _c(
                "td",
                {
                  staticStyle: { "background-color": "#E7EDF8" },
                  attrs: { colspan: "4" },
                },
                [_vm._v(" 纠纷内容 ")]
              ),
              _c("td", { staticClass: "border-n", attrs: { colspan: "12" } }, [
                _c(
                  "div",
                  {
                    staticStyle: { "line-height": "1.2", padding: "6px 0" },
                    attrs: { align: "center" },
                  },
                  [_vm._v(" " + _vm._s(row.dispute) + " ")]
                ),
              ]),
            ]),
            _c("tr", { staticClass: "border-b" }, [
              _vm._m(54, true),
              _c(
                "td",
                { staticClass: "border-n", attrs: { colspan: "20" } },
                _vm._l(_vm.dictionaries.recruit_origin, function (item, indz) {
                  return _c("span", { key: indz }, [
                    item.dictId == row.recruitOrigin
                      ? _c("span", [_vm._v(_vm._s(item.dictName))])
                      : _vm._e(),
                  ])
                }),
                0
              ),
            ]),
            _vm._m(55, true),
            _vm._m(56, true),
            _vm._m(57, true),
          ],
          2
        ),
        _vm._m(58, true),
      ])
    }),
    0
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "justify-content": "center",
          width: "100%",
          "padding-top": "30px",
        },
      },
      [
        _c(
          "div",
          { staticClass: "title", staticStyle: { "font-size": "28px" } },
          [_vm._v("应聘人员履历表")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticClass: "border-r",
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "4" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("应聘岗位")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticClass: "border-r",
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "4" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("填表日期")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticClass: "border-b-r",
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "2" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("姓名")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticClass: "border-b-r",
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "2" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("性别")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticClass: "border-b-r",
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "2" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("民族")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticClass: "border-b-r",
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "4" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("籍贯")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticClass: "border-b-r",
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "2" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("属相")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticClass: "border-b-r",
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "2" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("身高(cm)")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticClass: "border-b-r",
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "2" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("体重(kg)")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticClass: "border-b-r",
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "4" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("出生日期")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "4" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("政治面貌")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "4" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("联系电话")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "4", rowspan: "2" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("婚姻状况")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "4" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("微信号")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "4" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("最高学历")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "4" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("期待薪资")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "4" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("可到岗日期")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "4" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("身份证号码")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "4" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("户口性质")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "4" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("身份证详细地址")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "4" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("居住地详细地址")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "6" },
      },
      [
        _c(
          "div",
          { staticStyle: { "line-height": "1.3" }, attrs: { align: "center" } },
          [_vm._v("是否有朋友/亲戚在本公司服务")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "2" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("姓名")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "2" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("关系")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "2" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("部门")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "4" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("爱好/专长")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "4" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("汽（机）车驾照")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticStyle: { "line-height": "1.3" }, attrs: { align: "center" } },
      [_vm._v("教育经历"), _c("br"), _vm._v("（从高到低）")]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "4" } }, [
      _c("div", { attrs: { align: "center" } }, [_vm._v("起止时间")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "6" } }, [
      _c("div", { attrs: { align: "center" } }, [_vm._v("学校名称")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "4" } }, [
      _c("div", { attrs: { align: "center" } }, [_vm._v("专业")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "2" } }, [
      _c("div", { attrs: { align: "center" } }, [_vm._v("学历")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { staticClass: "border-n", attrs: { colspan: "4" } }, [
      _c("div", { attrs: { align: "center" } }, [_vm._v("教育类型")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticStyle: { "line-height": "1.3" }, attrs: { align: "center" } },
      [_vm._v("工作经历"), _c("br"), _vm._v("(从近到远)")]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "4" } }, [
      _c("div", { attrs: { align: "center" } }, [_vm._v("起止时间")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "4" } }, [
      _c("div", { attrs: { align: "center" } }, [_vm._v("单位名称")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "4" } }, [
      _c("div", { attrs: { align: "center" } }, [_vm._v("任职部门及职位名称")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "3" } }, [
      _c("div", { attrs: { align: "center" } }, [_vm._v("离职原因")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "3" } }, [
      _c("div", { attrs: { align: "center" } }, [_vm._v("证明人及其电话")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { staticClass: "border-n", attrs: { colspan: "2" } }, [
      _c("div", { attrs: { align: "center" } }, [_vm._v("月薪")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "4" } }, [
      _c("div", { attrs: { align: "center" } }, [_vm._v("起止时间")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "4" } }, [
      _c("div", { attrs: { align: "center" } }, [_vm._v("培训机构")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "4" } }, [
      _c("div", { attrs: { align: "center" } }, [_vm._v("获取证书")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "4" } }, [
      _c("div", { attrs: { align: "center" } }, [_vm._v("培训方式")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { staticClass: "border-n", attrs: { colspan: "4" } }, [
      _c("div", { attrs: { align: "center" } }, [_vm._v("培训内容")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "4" } }, [
      _c("div", { attrs: { align: "center" } }, [_vm._v("姓名")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "4" } }, [
      _c("div", { attrs: { align: "center" } }, [_vm._v("关系")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "4" } }, [
      _c("div", { attrs: { align: "center" } }, [_vm._v("工作单位")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "4" } }, [
      _c("div", { attrs: { align: "center" } }, [_vm._v("职务")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { staticClass: "border-n", attrs: { colspan: "4" } }, [
      _c("div", { attrs: { align: "center" } }, [_vm._v("联系电话(区+号码)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "4" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("紧急联系人姓名")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "4" } }, [
      _c("div", { attrs: { align: "center" } }, [_vm._v("紧急联系人电话")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "6" },
      },
      [
        _c(
          "div",
          {
            staticStyle: { "line-height": "1.2", padding: "6px 0" },
            attrs: { align: "center" },
          },
          [_vm._v("原单位是否存在纠纷")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: { "background-color": "#E7EDF8" },
        attrs: { colspan: "4" },
      },
      [_c("div", { attrs: { align: "center" } }, [_vm._v("招聘信息来源")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", { staticStyle: { "font-size": "12px" } }, [
      _c("td", { staticClass: "border-n", attrs: { colspan: "24" } }, [
        _c("div", [
          _vm._v(
            "应聘者需对以上填写资料真实性负责，我们会根据相关资料进行调查，如有不实，后果由应聘者自行承担"
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c(
        "td",
        { staticClass: "border-n1", attrs: { rowspan: "2", colspan: "16" } },
        [
          _c(
            "div",
            {
              staticStyle: { color: "#999999", "font-size": "14px" },
              attrs: { align: "center" },
            },
            [_vm._v("请各位应聘者确保以上信息真实有效，确认无误请签字")]
          ),
        ]
      ),
      _c("td", { attrs: { colspan: "2" } }, [_vm._v("姓名：")]),
      _c("td", { staticClass: "border-n", attrs: { colspan: "6" } }, [
        _vm._v(" "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "border-n1", attrs: { colspan: "2" } }, [
        _vm._v("日期："),
      ]),
      _c("td", { staticClass: "border-n border-n1", attrs: { colspan: "6" } }, [
        _vm._v(" "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "table",
      {
        staticClass: "table1",
        staticStyle: {
          "border-collapse": "collapse",
          "border-spacing": "0",
          border: "none",
          "table-layout": "fixed",
          "word-break": "break-word",
        },
        attrs: {
          width: "100%",
          height: "100%",
          cellpadding: "0",
          cellspacing: "0",
          border: "0",
        },
      },
      [
        _c("tr", [
          _c("td", {
            staticClass: "border-n",
            staticStyle: { height: "40px" },
            attrs: { colspan: "24" },
          }),
        ]),
        _c("tr", [
          _c(
            "td",
            {
              staticClass: "border-left",
              staticStyle: {
                "text-align": "center",
                "background-color": "#E7EDF8",
                height: "222px",
              },
              attrs: { colspan: "4", rowspan: "3" },
            },
            [_c("div", [_vm._v("行政人事意见")])]
          ),
          _c(
            "td",
            {
              staticStyle: {
                "vertical-align": "top",
                "text-align": "left",
                padding: "8px 6px",
              },
              attrs: { colspan: "20" },
            },
            [
              _c("div", [_vm._v("优势：")]),
              _c("div", [_vm._v(" ")]),
              _c("div", [_vm._v(" ")]),
              _c("div", [_vm._v(" ")]),
              _c("div", [_vm._v("不足：")]),
              _c("div", [_vm._v(" ")]),
              _c("div", [_vm._v(" ")]),
            ]
          ),
        ]),
        _c("tr", [
          _c("td", { attrs: { colspan: "20" } }, [
            _c(
              "div",
              { staticStyle: { padding: "8px 6px", "text-align": "left" } },
              [
                _c("span", { staticStyle: { "padding-right": "6px" } }, [
                  _vm._v("结论："),
                ]),
                _c("input", {
                  staticStyle: { "vertical-align": "middle" },
                  attrs: {
                    type: "checkbox",
                    name: "checkbox",
                    value: "checkbox",
                  },
                }),
                _c("span", { staticStyle: { margin: "0 24px 0 2px" } }, [
                  _vm._v("通知"),
                ]),
                _c("input", {
                  staticStyle: { "vertical-align": "middle" },
                  attrs: {
                    type: "checkbox",
                    name: "checkbox2",
                    value: "checkbox",
                  },
                }),
                _c("span", { staticStyle: { margin: "0 24px 0 2px" } }, [
                  _vm._v("不通知"),
                ]),
                _c("input", {
                  staticStyle: { "vertical-align": "middle" },
                  attrs: {
                    type: "checkbox",
                    name: "checkbox3",
                    value: "checkbox",
                  },
                }),
                _c("span", { staticStyle: { margin: "0 0 0 2px" } }, [
                  _vm._v("待定"),
                ]),
              ]
            ),
          ]),
        ]),
        _c("tr", [
          _c(
            "td",
            { staticStyle: { "text-align": "left" }, attrs: { colspan: "10" } },
            [
              _c("div", { staticStyle: { padding: "8px 6px" } }, [
                _vm._v("签名："),
              ]),
            ]
          ),
          _c(
            "td",
            { staticStyle: { "text-align": "left" }, attrs: { colspan: "10" } },
            [
              _c("div", { staticStyle: { padding: "8px 6px" } }, [
                _vm._v("日期："),
              ]),
            ]
          ),
        ]),
        _c("tr", [
          _c(
            "td",
            {
              staticClass: "border-left",
              staticStyle: {
                "text-align": "center",
                "background-color": "#E7EDF8",
                height: "222px",
              },
              attrs: { colspan: "4", rowspan: "3" },
            },
            [
              _c("div", { staticStyle: { "line-height": "1.2" } }, [
                _vm._v("用人部门面试意见"),
                _c("br"),
                _vm._v("(必填)"),
              ]),
            ]
          ),
          _c(
            "td",
            {
              staticStyle: {
                "vertical-align": "top",
                padding: "8px 6px",
                "text-align": "left",
              },
              attrs: { colspan: "20" },
            },
            [
              _c("div", [_vm._v("优势：")]),
              _c("div", [_vm._v(" ")]),
              _c("div", [_vm._v(" ")]),
              _c("div", [_vm._v(" ")]),
              _c("div", [_vm._v("不足：")]),
              _c("div", [_vm._v(" ")]),
              _c("div", [_vm._v(" ")]),
            ]
          ),
        ]),
        _c("tr", [
          _c("td", { attrs: { colspan: "10" } }, [
            _c(
              "div",
              { staticStyle: { padding: "8px 6px", "text-align": "left" } },
              [
                _c("span", { staticStyle: { "padding-right": "6px" } }, [
                  _vm._v("结论："),
                ]),
                _c("input", {
                  staticStyle: { "vertical-align": "middle" },
                  attrs: {
                    type: "checkbox",
                    name: "checkbox",
                    value: "checkbox",
                  },
                }),
                _c("span", { staticStyle: { margin: "0 24px 0 2px" } }, [
                  _vm._v("通知"),
                ]),
                _c("input", {
                  staticStyle: { "vertical-align": "middle" },
                  attrs: {
                    type: "checkbox",
                    name: "checkbox2",
                    value: "checkbox",
                  },
                }),
                _c("span", { staticStyle: { margin: "0 24px 0 2px" } }, [
                  _vm._v("不通知"),
                ]),
                _c("input", {
                  staticStyle: { "vertical-align": "middle" },
                  attrs: {
                    type: "checkbox",
                    name: "checkbox3",
                    value: "checkbox",
                  },
                }),
                _c("span", { staticStyle: { margin: "0 0 0 2px" } }, [
                  _vm._v("待定"),
                ]),
              ]
            ),
          ]),
          _c("td", { attrs: { colspan: "10" } }, [
            _c(
              "div",
              { staticStyle: { padding: "8px 6px", "text-align": "left" } },
              [
                _c("span", { staticStyle: { "padding-right": "6px" } }, [
                  _vm._v("简历是否合格："),
                ]),
                _c("input", {
                  staticStyle: { "vertical-align": "middle" },
                  attrs: {
                    type: "checkbox",
                    name: "checkbox",
                    value: "checkbox",
                  },
                }),
                _c("span", { staticStyle: { margin: "0 24px 0 2px" } }, [
                  _vm._v("是"),
                ]),
                _c("input", {
                  staticStyle: { "vertical-align": "middle" },
                  attrs: {
                    type: "checkbox",
                    name: "checkbox2",
                    value: "checkbox",
                  },
                }),
                _c("span", { staticStyle: { margin: "0 0 0 2px" } }, [
                  _vm._v("否"),
                ]),
              ]
            ),
          ]),
        ]),
        _c("tr", [
          _c(
            "td",
            { staticStyle: { "text-align": "left" }, attrs: { colspan: "10" } },
            [
              _c("div", { staticStyle: { padding: "8px 6px" } }, [
                _vm._v("签名："),
              ]),
            ]
          ),
          _c(
            "td",
            { staticStyle: { "text-align": "left" }, attrs: { colspan: "10" } },
            [
              _c("div", { staticStyle: { padding: "8px 6px" } }, [
                _vm._v("日期："),
              ]),
            ]
          ),
        ]),
        _c("tr", [
          _c(
            "td",
            {
              staticClass: "border-left",
              staticStyle: {
                "text-align": "center",
                "background-color": "#E7EDF8",
                height: "222px",
              },
              attrs: { colspan: "4", rowspan: "3" },
            },
            [_c("div", [_vm._v("总经理批示")])]
          ),
          _c(
            "td",
            {
              staticStyle: {
                "vertical-align": "top",
                padding: "8px 6px",
                "text-align": "left",
              },
              attrs: { colspan: "20" },
            },
            [
              _c("div", [_vm._v("优势：")]),
              _c("div", [_vm._v(" ")]),
              _c("div", [_vm._v(" ")]),
              _c("div", [_vm._v(" ")]),
              _c("div", [_vm._v("不足：")]),
              _c("div", [_vm._v(" ")]),
              _c("div", [_vm._v(" ")]),
            ]
          ),
        ]),
        _c("tr", [
          _c("td", { attrs: { colspan: "20" } }, [
            _c(
              "div",
              { staticStyle: { padding: "8px 6px", "text-align": "left" } },
              [
                _c("span", { staticStyle: { "padding-right": "6px" } }, [
                  _vm._v("结论："),
                ]),
                _c("input", {
                  staticStyle: { "vertical-align": "middle" },
                  attrs: {
                    type: "checkbox",
                    name: "checkbox",
                    value: "checkbox",
                  },
                }),
                _c("span", { staticStyle: { margin: "0 24px 0 2px" } }, [
                  _vm._v("通知"),
                ]),
                _c("input", {
                  staticStyle: { "vertical-align": "middle" },
                  attrs: {
                    type: "checkbox",
                    name: "checkbox2",
                    value: "checkbox",
                  },
                }),
                _c("span", { staticStyle: { margin: "0 24px 0 2px" } }, [
                  _vm._v("不通知"),
                ]),
                _c("input", {
                  staticStyle: { "vertical-align": "middle" },
                  attrs: {
                    type: "checkbox",
                    name: "checkbox3",
                    value: "checkbox",
                  },
                }),
                _c("span", { staticStyle: { margin: "0 0 0 2px" } }, [
                  _vm._v("待定"),
                ]),
              ]
            ),
          ]),
        ]),
        _c("tr", [
          _c(
            "td",
            { staticStyle: { "text-align": "left" }, attrs: { colspan: "10" } },
            [
              _c("div", { staticStyle: { padding: "8px 6px" } }, [
                _vm._v("签名："),
              ]),
            ]
          ),
          _c(
            "td",
            { staticStyle: { "text-align": "left" }, attrs: { colspan: "10" } },
            [
              _c("div", { staticStyle: { padding: "8px 6px" } }, [
                _vm._v("日期："),
              ]),
            ]
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }